import styles from './index.module.scss';
import GoogleButton from './GoogleButton';
import LoginForm from './LoginForm';
import { SupportLink } from './SupportLink';
import rootStyles from '../index.module.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../../services/loginService';
import { isEmpty } from 'lodash';
import { PrivacyLink } from './PrivacyLink';
import { Divider } from '@mui/material';
import SsoButton from './SsoButton';
import useIsPrimaryTheme from '../../../hooks/useIsPrimaryTheme';

function LoginContent() {
  const isPrimaryTheme = useIsPrimaryTheme();
  const {
    state: { forgotPassword, challenge, isWelcome, loginWithSso, profileStepOnComplete },
  } = useLoginService();

  return (
    <div
      className={classNames(styles.root, rootStyles.boxContainer, 'w-full', {
        [rootStyles.hide]:
          forgotPassword.value ||
          !isEmpty(challenge) ||
          isWelcome ||
          loginWithSso.value ||
          !!profileStepOnComplete,
        [classNames(styles.primaryP3Main, rootStyles.primaryP3Main)]: isPrimaryTheme,
      })}
    >
      <span className={rootStyles.title}>Log in to your account</span>
      <LoginForm />
      <div className={styles.loginDivider}>
        <Divider />
        <span>Or</span>
        <Divider />
      </div>
      <div className="flex flex-col w-full items-center">
        <GoogleButton />
        <SsoButton />
      </div>
      <SupportLink />
      <PrivacyLink />
    </div>
  );
}
export default observer(LoginContent);
